import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { typeLabels } from "@/utils/content";
import type { ContentType } from "@/types/content";

interface ShareRowProps {
  type: ContentType;
}

export default function ShareRow({ type }: ShareRowProps) {
  const [toast, setToast] = useState(false);

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => setToast(false), 2200);
    return () => clearTimeout(t);
  }, [toast]);

  const handleCopy = async () => {
    const url = window.location.href;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
      } else {
        const input = document.createElement("input");
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
      }
      setToast(true);
    } catch {
      setToast(true);
    }
  };

  return (
    <div className="mt-10 pt-6 border-t border-background-200 flex flex-wrap items-center justify-between gap-4">
      <div className="flex items-center gap-2">
        <span className="text-sm text-foreground-500 mr-1">分享本文：</span>
        <button
          type="button"
          onClick={handleCopy}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-50 text-primary-700 text-sm font-medium hover:bg-primary-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          <span className="w-4 h-4 flex items-center justify-center"><i className="ri-link"></i></span>
          复制链接
        </button>
        <button
          type="button"
          onClick={handleCopy}
          aria-label="分享"
          className="w-9 h-9 rounded-md border border-background-200 flex items-center justify-center text-foreground-600 hover:text-primary-700 hover:border-primary-300 transition-colors cursor-pointer"
        >
          <i className="ri-share-forward-line"></i>
        </button>
      </div>

      <Link
        to={`/category/${type}`}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-background-100 text-foreground-800 text-sm font-medium hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
      >
        <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-left-line"></i></span>
        返回{typeLabels[type]}
      </Link>

      {toast && (
        <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50 px-5 py-3 rounded-md bg-foreground-950 text-background-50 text-sm flex items-center gap-2 animate-fade-up">
          <span className="w-4 h-4 flex items-center justify-center text-accent-400"><i className="ri-checkbox-circle-line"></i></span>
          链接已复制到剪贴板
        </div>
      )}
    </div>
  );
}